"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCategories = void 0;
var _react = require("react");
var _contexts = require("../contexts");
/*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

/**
 * Custom React hook to get the categories
 * @returns {{categories: Object, setCategories: function}[]}
 */
const useCategories = () => {
  const context = (0, _react.useContext)(_contexts.CategoriesContext);
  if (context === undefined) {
    throw new Error('useCategories must be used within CategoriesProvider');
  }
  return context;
};
exports.useCategories = useCategories;